import React from 'react';
import {PolIcon} from "components/PolIcon/policon";
import './PolInfoBox.scss';

export default function PolInfoBox({
                                       icon,
                                       title,
                                       text,
                                       actions,
                                       className = '',
                                       isInfo,
                                       isSuccess,
                                       isWarning,
                                       isDanger,
                                       isIconInfo,
                                       isIconSuccess,
                                       isIconWarning,
                                       isIconDanger,
                                       children
                                   }) {
    let containerClassName = `${className} pol-info-box ${icon ? 'pol-info-box--with-icon' : ''}`;
    if (isInfo) {
        containerClassName += ' pol-info-box--info';
    } else if (isSuccess) {
        containerClassName += ' pol-info-box--success';
    } else if (isWarning) {
        containerClassName += ' pol-info-box--warning';
    } else if (isDanger) {
        containerClassName += ' pol-info-box--danger';
    }

    let iconClassName = 'pol-info-box__icon';
    if (isIconInfo) {
        iconClassName += ' pol-info-box__icon--info';
    } else if (isIconSuccess) {
        iconClassName += ' pol-info-box__icon--success';
    } else if (isIconWarning) {
        iconClassName += ' pol-info-box__icon--warning';
    } else if (isIconDanger) {
        iconClassName += ' pol-info-box__icon--danger';
    }

    return (
        <div className={containerClassName}>
            {icon && (
                <span className={iconClassName}>
                    <PolIcon icon={icon}/>
                </span>
            )}
            <div className="pol-info-box__content">
                {children
                    ? children
                    : (
                        <>
                            {title && <span className="pol-info-box__title">{title}</span>}

                            <div className="pol-info-box__content__text">
                                {`${text}`.length && <span className="pol-info-box__text">{text}</span>}
                                {actions && <span className="pol-info-box__actions">{actions()}</span>}
                            </div>
                        </>
                    )}
            </div>
        </div>
    )
}
